import { Modal, Button, Typography } from "antd";
import { GoogleOutlined, LinkedinOutlined } from "@ant-design/icons";
import apiClient from "QueryClient/axiosClient";
import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "Constants/AllRoutes";
import { useUserInfo } from "GlobalStates/User";
import { useLoginWithGoogle } from "Hooks/useGoogleLogin";

const { Title, Text } = Typography;

const loginUserWithGoogleToken = (data) => {
  return apiClient.post("/auth/googleLogin", data);
};

const LoginModal = ({ open, onClose, onGoogleLogin, onLinkedInLogin }) => {
  const { setUser } = useUserInfo();
  const navigate = useNavigate();
  const loginUserMutation = useMutation({
    mutationFn: loginUserWithGoogleToken,
    onSuccess: (data) => {
      setUser({
        token: data?.data?.accessToken,
        name: data?.data?.name,
        role: data?.data?.role,
        hasCompletedProfile: data?.data?.hasCompletedProfile,
        isVerified: data?.data?.isVerified,
        picture: data?.data?.picture,
      });
      if (data?.data?.hasCompletedProfile) {
        navigate(ROUTES.MY_CALENDAR);
      } else {
        navigate(ROUTES.REGISTER_ROLE);
      }
    },
  });
  const generateGoogleToken = useLoginWithGoogle({
    onSuccessCallback: async (user) => {
      try {
        await loginUserMutation.mutateAsync({ token: user?.access_token });
        onGoogleLogin();
      } catch (err) {
        console.log(err);
      }
    },
  });
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      width={400}
      destroyOnClose
    >
      <Title level={4} style={{ textAlign: "center" }}>
        Sign in to your account
      </Title>

      <Text
        type="secondary"
        style={{ display: "block", textAlign: "center", marginBottom: 24 }}
      >
        Choose a provider to continue
      </Text>

      <Button
        block
        size="large"
        icon={<GoogleOutlined />}
        onClick={() => {
          console.log("clicked");
          generateGoogleToken();
        }}
        style={{ marginBottom: 12 }}
      >
        Continue with Google
      </Button>

      <Button
        block
        size="large"
        icon={<LinkedinOutlined />}
        onClick={onLinkedInLogin}
        style={{ backgroundColor: "#0A66C2", color: "#fff" }}
      >
        Continue with LinkedIn
      </Button>
    </Modal>
  );
};

export default LoginModal;
